import { FormArray, FormControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function conditionalValidator(
  predicate: () => boolean,
  validator: ValidatorFn
): (formControl: FormControl) => ValidationErrors | null {
  return (formControl: FormControl): ValidationErrors | null => {
    if (!formControl.parent) {
      return null;
    }

    if (predicate()) {
      return validator(formControl);
    }

    return null;
  };
}

export function minLengthArray(min: number): ValidatorFn {
  return (control: FormArray): ValidationErrors | null => {
    if (control.length >= min) {
      return null;
    }

    return { minLengthArray: { requiredLength: min, actualLength: control.length } };
  };
}

export type ExtractFormControl<T> = {
  [K in keyof T]: T[K] extends FormControl<infer U>
    ? U
    : T[K] extends FormArray<FormControl<infer Z>>
      ? Z[]
      : T[K];
};
